import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSchufaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 15,
			width: 19.3045,
			height: 4.19499,
			rx: .91767,
			fill: "#F3C743"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 29.1582,
			width: 19.3045,
			height: 4.19499,
			rx: .91767,
			fill: "#F3C743"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.6953,
			y: 22.3408,
			width: 19.3045,
			height: 4.19499,
			rx: .91767,
			fill: "#F3C743"
		})
	]
});
export default SvgSchufaIcon;
